const resizeEvent = {
    data () {
        return {
            isMobile:false,
        }
    },
    created(){
        this.handleResize();
    },
    mounted(){
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy(){
        window.removeEventListener("resize", this.handleResize);
    },
    methods:{
        handleResize(){
            this.isMobile = document.body.clientWidth < 1200;
        }
    }
}
export default resizeEvent;
